import styled from 'styled-components'

import { ButtonAsync } from '@subaio/components'

import { helpers } from 'styles'

export const ButtonSolid = styled(ButtonAsync)`
	font-size: ${helpers.font.size.base};
	font-weight: 600;
	color: ${helpers.color.textButton};
	background-color: ${helpers.color.primary};
	border-radius: 2px;
	min-height: 40px;
	min-width: 120px;
	padding: 8px 30px;
	transition: background-color 135ms ease;
	margin: 0;
	height: unset;

	&:focus-visible {
		outline: 2px solid ${helpers.color.buttonFocus};
	}

	&:active {
		background-color: ${helpers.color.primaryActive};
	}

	&:disabled {
		color: ${helpers.color.disabled};
		background-color: ${helpers.color.disabledContrast};
		box-shadow: none;
	}

	.label {
		white-space: normal;
		overflow: visible;
		text-overflow: clip;
	}
`
